import SectionHeader from "./SectionHeader";
import { timelinePhases } from "@/pages/home/data/timeline";

export default function Timeline() {
  return (
    <section id="timeline" className="bg-background-50">
      <div className="mx-auto max-w-[1100px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeader
          eyebrow="舆情时间线"
          title="塌房后 72 小时，舆论如何完成一轮循环"
          description="把几十个匿名样本的演变轨迹压缩成一条典型时间线，帮你在吃瓜时预判情绪走向，不被单点爆料牵着走。"
          align="center"
        />

        <div className="relative mt-12">
          {/* center rail */}
          <div
            className="pointer-events-none absolute left-4 top-0 hidden h-full w-px bg-gradient-to-b from-accent-300 via-primary-300 to-secondary-300 md:left-1/2 md:-translate-x-1/2"
            aria-hidden="true"
          ></div>

          <div className="space-y-8 md:space-y-4">
            {timelinePhases.map((phase, i) => {
              const isLeft = i % 2 === 0;
              return (
                <div
                  key={phase.label}
                  className="relative grid grid-cols-[1fr] items-center gap-4 md:grid-cols-[1fr_auto_1fr]"
                >
                  {/* spacer (desktop) */}
                  <div className="hidden md:block">{isLeft ? null : <div></div>}</div>

                  {/* card */}
                  <div className={`pl-12 md:pl-0 ${isLeft ? "md:col-start-1 md:pr-12 md:text-right" : "md:col-start-3 md:pl-12 md:text-left"}`}>
                    <article
                      className={`inline-block w-full max-w-[520px] rounded-xl border border-background-200 bg-background-100 p-5 md:p-6 ${
                        isLeft ? "md:text-left" : ""
                      }`}
                    >
                      <div className="flex flex-wrap items-center gap-2">
                        <span className="font-heading text-lg font-bold text-accent-700">{phase.window}</span>
                        <span className="rounded-full bg-primary-100 px-2.5 py-0.5 text-xs font-medium text-primary-800">
                          {phase.label}
                        </span>
                      </div>
                      <h3 className="mt-2 font-heading text-lg font-bold text-foreground-950">{phase.headline}</h3>
                      <p className="mt-2 text-sm leading-relaxed text-foreground-700">{phase.description}</p>
                      <ul className="mt-3 flex flex-wrap gap-2">
                        {phase.signals.map((s) => (
                          <li
                            key={s}
                            className="whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900"
                          >
                            {s}
                          </li>
                        ))}
                      </ul>
                    </article>
                  </div>

                  {/* center node */}
                  <div className="absolute left-4 top-1/2 -translate-y-1/2 md:static md:col-start-2 md:translate-y-0">
                    <span
                      className={`flex h-9 w-9 items-center justify-center rounded-full border-2 text-sm font-semibold md:mx-auto ${
                        i % 2 === 0
                          ? "border-primary-400 bg-primary-500 text-background-50"
                          : "border-secondary-400 bg-secondary-500 text-background-50"
                      }`}
                    >
                      {i + 1}
                    </span>
                  </div>

                  {/* spacer (desktop) */}
                  <div className="hidden md:block">{isLeft ? <div></div> : null}</div>
                </div>
              );
            })}
          </div>
        </div>

        <p className="mt-10 text-center text-xs leading-relaxed text-foreground-500">
          本时间线基于公开讨论演化归纳，用于理解粉丝反应节奏，不代表对任何具体事件的定性。
        </p>
      </div>
    </section>
  );
}